<main class="payment-container">
  <div class="payment-content">
    <h1 class="payment-title">{{ "payment.title" | translate }}</h1>

    <div class="plans-loading" *ngIf="!pricesLoaded">
      <div class="plans-spinner" aria-label="loading"></div>
    </div>

    <div class="plans-grid" *ngIf="pricesLoaded">
      <!-- One-time 30-day pass (no auto-renew) -->
      <div class="plan-card" *ngIf="!storeMode || storeProducts.onetime">
        <div class="plan-tag">{{ "payment.oneTime.tag" | translate }}</div>

        <div class="plan-header">
          <h2 class="plan-name">{{ "payment.oneTime.name" | translate }}</h2>
          <p class="plan-price">
            <span class="current-price">{{ oneTimeDisplay }}</span>
          </p>
        </div>

        <div class="plan-features">
          <div class="feature-item">
            <span class="bullet">•</span>
            <span class="feature-text">{{ "payment.oneTime.feature1" | translate }}</span>
          </div>
        </div>

        <p class="billing-clarity">{{ "payment.oneTime.billing" | translate }}<br />{{ "payment.oneTime.access" | translate }}</p>

        <button
          class="plan-button"
          mat-raised-button
          (click)="storeMode ? storeBuy('onetime') : selectOneTime()"
          [disabled]="isProcessing"
        >
          {{
            processingPlanId === "onetime"
              ? ("payment.processing" | translate)
              : ("payment.oneTime.button" | translate)
          }}
        </button>
      </div>

      <!-- Recurring subscription with annual/monthly selector -->
      <div class="plan-card subscription-card" *ngIf="!storeMode || storeProducts.monthly || storeProducts.annual">
        <div class="plan-header">
          <h2 class="plan-name">{{ "payment.subscription.name" | translate }}</h2>

          <div class="billing-selector" role="tablist">
            <button
              type="button"
              class="seg"
              role="tab"
              [attr.aria-selected]="selectedBilling === 'annual'"
              [class.active]="selectedBilling === 'annual'"
              (click)="setBilling('annual')"
            >
              {{ "payment.subscription.annualLabel" | translate }}
            </button>
            <button
              type="button"
              class="seg"
              role="tab"
              [attr.aria-selected]="selectedBilling === 'monthly'"
              [class.active]="selectedBilling === 'monthly'"
              (click)="setBilling('monthly')"
            >
              {{ "payment.subscription.monthlyLabel" | translate }}
            </button>
          </div>

          <!-- Savings are computed from the two real prices (same platform, same
               currency) and rounded down; hidden when they cannot be trusted. -->
          <div class="saving-badge" *ngIf="selectedBilling === 'annual' && annualSavePct">
            {{ "payment.subscription.saveBadge" | translate: { pct: annualSavePct } }}
          </div>

          <p class="plan-price" *ngIf="subPrimary">
            <span class="current-price">{{ subPrimary }}</span>
            <span class="per-month">{{ subPerKey | translate }}</span>
          </p>
          <p class="price-equiv" *ngIf="selectedBilling === 'annual' && annualEquivalent">{{ annualEquivalent }}</p>
        </div>

        <div class="plan-features">
          <div class="feature-item">
            <span class="bullet">•</span>
            <span class="feature-text">{{ "payment.subscription.feature1" | translate }}</span>
          </div>
        </div>

        <p class="billing-clarity">{{ subBillingKey | translate }}</p>

        <button
          class="plan-button subscription-button"
          mat-raised-button
          (click)="storeMode ? storeBuy(selectedBilling) : selectSubscription()"
          [disabled]="isProcessing"
        >
          {{
            processingPlanId === "annual" || processingPlanId === "monthly"
              ? ("payment.processing" | translate)
              : (subButtonKey | translate)
          }}
        </button>
      </div>
    </div>

    <!-- Store billing (native apps): messages, renewal terms, restore, legal links -->
    <div class="store-footer" *ngIf="storeMode && pricesLoaded">
      <p class="store-msg" *ngIf="storeMessage" role="status">{{ storeMessage }}</p>
      <p class="store-terms" *ngIf="storeProducts.monthly || storeProducts.annual">
        {{ "payment.store.autoRenewNote" | translate: { store: storeName } }}
      </p>
      <button type="button" class="store-restore" (click)="storeRestore()" [disabled]="isProcessing">
        {{ (restoring ? "payment.store.restoring" : "payment.store.restore") | translate }}
      </button>
      <div class="store-links">
        <a [href]="brandService.config.termsOfUseUrl" target="_blank" rel="noopener">{{ "payment.store.terms" | translate }}</a>
        <span aria-hidden="true">·</span>
        <a [href]="brandService.config.privacyPolicyUrl" target="_blank" rel="noopener">{{ "payment.store.privacy" | translate }}</a>
      </div>
    </div>
  </div>
</main>
